<!--
  --
  -- オプションカード
  --
  -->
<template>
  <v-card>
    <v-card-title>オプション</v-card-title>

    <v-card-text class="mt-n4">
      <!-- 免責補償 -->
      <template v-if="insurance.id !== 0">
        <c-title-row>免責補償サービス</c-title-row>
        <c-data-row :indent="1" :label="insurance.name" :charge="insurance.charge"/>
      </template>

      <!-- オプション -->
      <template v-if="options.length > 0">
        <c-title-row>オプション</c-title-row>

        <c-data-row
          v-for="item in options"
          :key="item.id"
          :indent="1"
          :label="item.name"
          :quantity="(item.quantity === 1 && item.unit === '') ? undefined : item.quantity"
          :unit="item.unit"
          :charge="item.charge"
        />
      </template>

      <!-- 送迎 -->
      <template v-if="pick.value !== WAY_NONE">
        <c-title-row>送迎サービス</c-title-row>
        <c-data-row :indent="1" :label="pick.name" :charge="pick.charge"/>
        <c-data-row v-if="pick.place" :indent="1" :label="pick.place"/>
      </template>

      <!-- 配車 -->
      <template v-if="deli.value !== WAY_NONE">
        <c-title-row>配車サービス</c-title-row>
        <c-data-row :indent="1" :label="deli.name" :charge="deli.charge"/>
        <c-data-row v-if="deli.place" :indent="1" :label="deli.place"/>
      </template>

      <!-- 乗り捨て -->
      <template v-if="returns.station">
        <c-title-row>乗り捨てサービス</c-title-row>
        <c-data-row :indent="1" :label="returns.station.name" :charge="returns.charge"/>
      </template>

      <c-divider/>
      <c-total-row label="追加料金 小計" :charge="charge.additional"/>
    </v-card-text>
  </v-card>
</template>

<script>
import CTitleRow from './CTitleRow'
import CDataRow from './CDataRow'
import CTotalRow from './CTotalRow'
import CDivider from './CDivider'

import * as C from '@/consts'

export default {
  name: 'COptionsCard',
  components: {
    CTitleRow,
    CDataRow,
    CTotalRow,
    CDivider
  },

  data: () => ({
    WAY_NONE: C.WAY_NONE,
    WAY_START: C.WAY_NONE,
    WAY_RETURN: C.WAY_RETURN,
    WAY_ROUND: C.WAY_ROUND
  }),

  computed: {
    options () {
      return this.getters['book/options']
    },

    insurance () {
      return this.getters['book/insurance']
    },

    pick () {
      return this.getters['book/pick']
    },

    deli () {
      return this.getters['book/deli']
    },

    returns () {
      return this.getters['book/returns']
    },

    charge () {
      return this.getters['book/charge']
    }
  }

}
</script>
